<template>
  <a-modal
    :visible="visible"
    :title="record ? '编辑变体' : '添加变体'"
    width="520px"
    ok-text="确认"
    cancel-text="取消"
    :mask-closable="false"
    @ok="handleConfirm"
    @cancel="$emit('update:visible', false)"
  >
    <a-form layout="vertical" @submit.prevent="handleConfirm">
      <a-form-item
        label="变体名称"
        required
        :validate-status="error?.field === 'variantName' ? 'error' : undefined"
        :help="error?.field === 'variantName' ? error.message : undefined"
      >
        <a-input
          v-model:value="form.variantName"
          placeholder="请输入变体名称，最多 64 个字符"
        />
      </a-form-item>
      <a-form-item
        label="变体标识"
        required
        :validate-status="error?.field === 'variantKey' ? 'error' : undefined"
        :help="error?.field === 'variantKey' ? error.message : undefined"
      >
        <a-input
          v-model:value="form.variantKey"
          placeholder="请输入实验内唯一的变体标识，最多 64 个字符"
        />
      </a-form-item>
    </a-form>
    <p v-if="!record" class="hint">
      新增变体从空列表开始，请添加物料并设置默认选中的 Tab。
    </p>
  </a-modal>
</template>

<script>
import { reactive, ref, watch } from 'vue'
import { validateVariantInfo } from '../configDraft'

export default {
  props: {
    visible: Boolean,
    record: { type: Object, default: null },
    variants: { type: Array, default: () => [] }
  },
  emits: ['update:visible', 'confirm'],
  setup(props, { emit }) {
    const form = reactive({ variantName: '', variantKey: '' })
    const error = ref(null)
    watch(
      () => props.visible,
      () => {
        form.variantName = props.record?.variantName || ''
        form.variantKey = props.record?.variantKey || ''
        error.value = null
      }
    )
    const handleConfirm = () => {
      const variant = {
        uiId: props.record?.uiId,
        variantName: form.variantName.trim(),
        variantKey: form.variantKey.trim()
      }
      error.value = validateVariantInfo(variant, props.variants)
      if (!error.value) emit('confirm', variant)
    }
    return { error, form, handleConfirm }
  }
}
</script>

<style scoped>
.hint {
  color: #8c8c8c;
  font-size: 12px;
}
</style>
